/**
 * 手机端整体结构搭建
 */
import React,{Component} from 'react';
// import MobileHeader from './mobile_header'

import '../components_css/mobile.css'
export default class MobileApp extends Component{
  render(){
    return (
      <div  id="rootInMobile">
        {/* <MobileHeader></MobileHeader> */}
        
        {this.props.children}
        
      </div>
    )
  }
}






// WEBPACK FOOTER //
// ./src/components/mobile_app.jsx